export default "__VITE_ASSET__B4WqOU2n__"